import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useViralReels(periodDays = 30, limit = 50) {
  return useQuery({
    queryKey: analyticsKeys.viralReels(periodDays, limit),
    queryFn: () => analyticsApi.viralReels(periodDays, limit),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
  });
}
